import React, {useContext, useState} from "react";
import {Input, Label} from "reactstrap";
import {InputHelp} from "./InputHelp";
import PropTypes from "prop-types";
import {Trans} from "@lingui/react";
import {FocusedNodeContext} from "../../Service/Context/FocusedNode";

export const SimpleEditableText = ({finishCallback, value: initialValue, placeholder, patchField, style, labelStyle, ...rest}) => {
    const [value, setValue] = useState(initialValue);
    const [error, setError] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const {setListPosition} = useContext(FocusedNodeContext);

    function focusNode(e) {
        setListPosition(rest.index);
    }

    let styles = {
        error: {
            borderColor: "red",
        },
        input: {
            marginBottom: 0,
        },
        label: {
            color: "#8ca3b5",
            fontWeight: 800,
            ...labelStyle
        },
        inputContainer: {
            marginBottom: 9,
            ...style
        }
    };

    return (
        <div style={styles.inputContainer}>
            <Input onBlur={() => {
                setLoading(true);
                finishCallback({[patchField]: value}).catch((error) => setError(error.message)).finally(() => {
                    setLoading(false);
                })
            }}
                   className={loading ? "loading" : ""}
                   style={error ? {...styles.error, ...styles.input} : styles.input}
                   onFocus={focusNode}
                   onChange={e => setValue(e.target.value)}
                   onKeyUp={e => {
                       switch (e.key) {
                           case 'Enter':
                               finishCallback({[patchField]: value}).catch((error) => setError(error.message)).then(() => setLoading(false));
                               break;
                           case "Escape":
                               finishCallback({[patchField]: initialValue}).catch((error)  => setError(error.message)).then(() => setLoading(false));
                       }
                   }}
                   value={value != null ? value : ""} {...rest}/>
            {placeholder && <Label sm={12} style={styles.label}><Trans id={placeholder || ''}/></Label>}
            {error ? <InputHelp errorDescription={error}/> : null}
        </div>
    )

};

SimpleEditableText.propTypes = {
    value: PropTypes.string,
    finishCallback: PropTypes.func,
    autoFocus: PropTypes.bool,
};

SimpleEditableText.defaultProps = {
    autoFocus: true,
};